__webpack_require__.p = "/anime-otaku/";